import { ICellTypeHandler } from "components/grecoreactgrid/ICellTypeHandler";
import { InsurerReportOptionsCellTemplate } from "../customcells/InsurerReportOptionsCellTemplate";

class InsurerReportOptionsCellTypeHandler implements ICellTypeHandler {
  cellType = "insurerreportoptions";
  isCustom = true;
  instance = new InsurerReportOptionsCellTemplate();
  determineNewValue = (change: any) => {
    return (change.newCell as any).text;
  };
  getEntryRow = (
    entry: any,
    columnConfig: any,
    rowsMetadataMap: any,
    keyColumn: string,
    context: {
      [key: string]: any;
    }
  ) => {
    const [, { setInsurerReportsStoreValues }] =
      context["insurerReportsStore"];
    const { t } = context;

    return {
      type: "insurerreportoptions",
      rowId: columnConfig.additionalInfo?.rowIdField
        ? entry[columnConfig.additionalInfo.rowIdField]
        : "",
      link: columnConfig.additionalInfo?.linkField
        ? entry[columnConfig.additionalInfo.linkField]
        : "",
      selected: rowsMetadataMap[entry[keyColumn]]?.selected ?? false,
      highlighted: rowsMetadataMap[entry[keyColumn]]?.highlighted ?? false,
      deleteFn: (rowId) => {
        setInsurerReportsStoreValues({
          deleteInsurerReportDialog: {
            isOpen: true,
            insurerReportId: rowId,
          },
        });
      },
      matchFn: (rowId) => {
        setInsurerReportsStoreValues({
          matchInsurerReportDialog: {
            isOpen: true,
            insurerReportId: rowId,
          },
        });
      },
      t,
    };
  };
}

export default InsurerReportOptionsCellTypeHandler;
